<template>
<v-app id="appRoot">
    <template v-if="!$route.meta.public">
        <v-app id="inspire" class="app">
            <app-drawer class="app--drawer"></app-drawer>
            <app-toolbar class="app--toolbar"></app-toolbar>
            <v-content class="bgbody">
                
                <div class="page-wrapper">
                    <router-view @authenticated="setAuthenticated"></router-view>
                </div>
                
            </v-content>
            <v-footer height="auto" class="footerCss pa-3 app--footer" color="dark">
                <v-layout row wrap text-xs-center text-md-left>
                    <v-flex md6 xs12 order-md1 order-xs2 pos-footer>
                     <span class="sicon">
                        <a href="https://www.loadmax.com" target="_blank" ><img src="/static/LOADMAXIcon.png" height="32px" /></a>
                     </span>
                     <img src="/static/STAYLOADED..png" class="stayload">
                     <span class="caption"> &copy; {{ new Date().getFullYear() }}  <a class="link-text" href="http://www.LOADMAX.com" target="_blank">LOADMAX, LLC</a>. All rights reserved.</span>
                    </v-flex>
                    <v-flex md6 xs12 text-xs-center text-md-right order-lg2 order-md2 >

                        <span class="caption captionmargin">
                     <router-link :to="{ name: 'termsConditions'}">
                         Terms of Service
                    </router-link>
                    |
                     <router-link :to="{ name: 'privacyPolicy'}">
                         Privacy Policy
                    </router-link>
                     |  
                     <router-link :to="{ name: 'advertise'}">
                         Advertise with LOADMAX
                    </router-link>| 
                    <a :href="`mailto:${contactEmailAddress}`">
                        Contact
                    </a>
                     </span>
                    
                    </v-flex>
                </v-layout>
            </v-footer>
            <!-- Go to top -->
            <app-fab></app-fab>
            <ChatBot v-if="this.$route.name != 'FastPost'"></ChatBot>
            <v-btn v-if="this.$store.state.user && typeof this.$store.state.user.back_user_uuid != 'undefined' && this.$store.state.user.back_user_uuid != ''" color="orange" class="custstom_back" @click="mirrorUser();">
                <i class="fas fa-arrow-left"></i> Back to Admin
            </v-btn>
            <!-- theme setting -->
            <!--START:SLIDER-->
            
            <div class="slider_wrapper homeslider" v-if="this.$store.state.user && this.$store.state.user.pin_no_tmp == '' && (typeof this.$store.state.user.back_user_uuid == 'undefined' || this.$store.state.user.back_user_uuid == '') && !clientUserAgent && !this.$store.state.user.isImr">
                <template id="slider">
                    <Slider
                        animation="fade"
                        :autoplay="false"
                        :height="sliderHeight"
                        @change="hideShowPrevNext($event)"
                        >
                        <SliderItem>
                            <TutorialSlideOne></TutorialSlideOne>
                        </SliderItem>
                        <SliderItem>
                            <TutorialSlideTwo></TutorialSlideTwo>
                        </SliderItem>
                        <SliderItem>
                            <TutorialSlideThree></TutorialSlideThree>
                        </SliderItem>
                        <SliderItem>
                            <TutorialSlideFour></TutorialSlideFour>
                        </SliderItem>
                        <SliderItem>
                            <TutorialSlideFive></TutorialSlideFive>
                            <GeneratePin></GeneratePin>
                        </SliderItem>
                    </Slider>
                </template>
            </div>
            <div class="slider_wrapper homeslider" v-if="this.$store.state.user && this.$store.state.user.pin_no == 'NULL' && this.$store.state.user.pin_no_tmp == 'NULL' && (typeof this.$store.state.user.back_user_uuid == 'undefined' || this.$store.state.user.back_user_uuid == '') && !clientUserAgent && !this.$store.state.user.isImr">
                <template id="slider">
                    <Slider
                        animation="fade"
                        :autoplay="false"
                        :height="sliderHeight"
                        :control-btn="false"
                        :indicators="false"
                        >
                        <SliderItem>
                            <TutorialSlideFive></TutorialSlideFive>
                            <GeneratePin></GeneratePin>
                        </SliderItem>
                    </Slider>
                </template>
            </div>
            <!--STOP:SLIDER-->
        </v-app>
    </template>
    <template v-else>
        <transition>
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </transition>
    </template>
    <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.text }}
        <v-btn dark flat @click.native="snackbar.show = false" icon>
            <v-icon>close</v-icon>
        </v-btn>
    </v-snackbar>
    <v-dialog v-model="ajaxModal.show" persistent width="300">
        <v-card color="dark" dark>
            <v-card-text>
                {{ajaxModal.msg}}
                <v-progress-linear indeterminate color="orange" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</v-app>
</template>
<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import AppFab from "@/components/AppFab";
import PageHeader from "@/components/PageHeader";
import menu from "@/api/menu";
import ThemeSettings from "@/components/ThemeSettings";
import AppEvents from "./event";
import config from "./config";
import ChatBot from "@/components/ChatBot";
import { Slider, SliderItem } from "vue-easy-slider";
import TutorialSlideOne from "@/components/tutorial-sliders/TutorialSlideOne";
import TutorialSlideTwo from "@/components/tutorial-sliders/TutorialSlideTwo";
import TutorialSlideThree from "@/components/tutorial-sliders/TutorialSlideThree";
import TutorialSlideFour from "@/components/tutorial-sliders/TutorialSlideFour";
import TutorialSlideFive from "@/components/tutorial-sliders/TutorialSlideFive";
import GeneratePin from "@/components/GeneratePin";
import {
    constants
} from 'fs';
import {
    mapActions
} from "vuex";
import services from "./services/HttpService";
import utils from "./util/";
import { setTimeout } from 'timers';
export default {
    components: {
        AppDrawer,
        AppToolbar,
        AppFab,
        PageHeader,
        ThemeSettings,
        ChatBot,
        Slider,
        SliderItem,
        TutorialSlideOne,
        TutorialSlideTwo,
        TutorialSlideThree,
        TutorialSlideFour,
        TutorialSlideFive,
        GeneratePin
    },
    data: () => ({
        ajaxModal: {
            show: false,
            msg: 'Loading...'
        },
        snackbar: {
            show: false,
            text: "",
            color: ""
        },
        authenticated: false,
        expanded: true,
        rightDrawer: false,
        contactEmailAddress: config.contactEmailAddress,
        sliderHeight:'',
        clientUserAgent: config.clientUserAgent,
        isLogedIn:false,
    }),
    computed: {
    },
    created() {
        const self = this;
        self.sliderHeight = (Math.max(document.documentElement.clientHeight, window.innerHeight || 0)+'px').toString();
        AppEvents.forEach(item => {
            self.$on(item.name, item.callback);
        });
        self.$on('showLoader', function (data) {
            self.ajaxModal.show = data.show ? data.show : false;
            if (data.msg) {
                self.ajaxModal.msg = data.msg
            }
        });
        self.$on('showSnackbar', function (data) {
            self.snackbar.color = data.color ? data.color : 'green';
            if (data.msg) {
                self.snackbar.show = true;
                self.snackbar.text = data.msg
            }
        });
        window.getApp = self;
    },
    mounted() {
        const self = this;
        self.clientUserAgent = utils.getUserAgent();
        // let scriptForMapApi = document.getElementById('scriptForMapApi');
        // if(scriptForMapApi){
        //     scriptForMapApi.setAttribute("src", config.scriptForMapApi);
        // }        
    },
    methods: {
        ...mapActions(["login"]),
        hideShowPrevNext(event){
            if(event==4){
                document.getElementsByClassName("slider-btn-right")[0].style.display = 'none';
            }else{
                document.getElementsByClassName("slider-btn-right")[0].style.display = 'block';
            }
            if(event==0){
                document.getElementsByClassName("slider-btn-left")[0].style.display = 'none';
            }else{
                document.getElementsByClassName("slider-btn-left")[0].style.display = 'block';
            }
        },
        openThemeSettings() {
            this.$vuetify.goTo(0);
            this.rightDrawer = !this.rightDrawer;
        },
        setAuthenticated(status) {
            this.authenticated = status;
        },
        logout() {
            this.authenticated = false;
        },
        _getPermissionsMapping(data) {
            let permMap = {};
            const perm = data.permissionSets;
            if (perm.length) {
                for (let i = 0; i < perm.length; i++) {
                    const permissions = perm[i].Role.ModulePermissions;
                    if (permissions.length) {
                        for (let j = 0; j < permissions.length; j++) {
                            const _pObj = permissions[j],
                                moduleName = _pObj.Module.slug,
                                permType = _pObj.p_name;
                            if (permMap[moduleName] !== "all") {
                                permMap[moduleName] = permType;
                            }
                        }
                    }
                }
            }
            return permMap;
        },
        mirrorUser() {
            const self = this;
            utils.mirrorUser(self.$store.state.user.back_user_uuid, '',self, function (userData){
                if(userData.user_profile_pic==""){
                    userData.user_profile_pic = config.defaultProfilePicPath;
                }Slider,
        SliderItem,
                self.login({
                    user: userData
                });
                window.location.href = '/dashboard';
            });
            
        }
    }
};
</script>
<style lang="stylus">
.ldmx-form .v-text-field__suffix
    color: #ff5252 !important;
.footerCss
  z-index: 3;
  background: #252525!important;
  color: #fff!important;
#slider
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  height:500px !important;
.homeslider .slider-item
  background-color: rgb(1, 3, 14);
.homeslider  .slider-items
    height: 100% !important;
    width:100% !importnat;
    box-sizing: border-box !important;
    position:fixed;
.homeslider.slider_wrapper
    position:fixed;
    background:rgba(0,0,0,0.08);
    width:100%;
    height:100%;
    z-index:999
.homeslider .slider-btn-left
    display:none;
</style>




// WEBPACK FOOTER //
// src/App.vue